import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Placeholder, Col } from 'rsuite'

export default function BackgroundExerciseActivityView({ schema }) {
  const { Graph } = Placeholder

  const styles = {
    marginTop1em: {
      marginTop: '1em',
    },
    marginLeft1em: {
      marginLeft: '1em',
    },
    marginTop2em: {
      marginTop: '2em',
    },
    styleHeaderTable: { whiteSpace: 'normal' },
  }

  const [dataConsumeSmoking, setDataConsumeSmoking] = useState([])
  const [smokerPerSex, setSmokerPerSex] = useState([])

  useEffect(() => {}, [schema])

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row style={styles.marginTop1em}>
            <Col>
              <b>{schema.numOfPopulation.label}</b>
            </Col>
          </Row>
          <Row style={styles.marginTop1em}>
            <Col xs={24} sm={24} md={6} lg={6} style={{ textAlign: 'center' }}>
              <p>
                <b>ช่วงวัย</b>
              </p>
            </Col>
            <Col xs={24} sm={24} md={4} lg={4} style={{ textAlign: 'center' }}>
              <p>
                <b>
                  {schema.childhood.preLabel} {schema.childhood.postLabel}
                </b>
              </p>
            </Col>
            <Col xs={24} sm={24} md={14} lg={14}>
              <b>{schema.childhoodBehavior.hint}</b>
            </Col>
            <Row>
              <Col xs={24} sm={24} md={6} lg={6}>
                <p>{schema.childhood.label}</p>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} style={{ textAlign: 'center' }}>
                <p>{schema.childhood.value}</p>
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <div>{schema.childhoodBehavior.value}</div>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={6} lg={6}>
                <p>{schema.workingAge.label}</p>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} style={{ textAlign: 'center' }}>
                <p>{schema.workingAge.value}</p>
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <p> {schema.workingAgeBehavior.value}</p>
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={24} md={6} lg={6}>
                <p>{schema.oldAge.label}</p>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} style={{ textAlign: 'center' }}>
                <p>{schema.oldAge.value}</p>
              </Col>
              <Col xs={24} sm={24} md={14} lg={14}>
                <p>{schema.oldAgeBehavior.value}</p>
              </Col>
            </Row>
          </Row>

          <Row style={styles.marginTop1em}>
            <p>{schema.healthProblems.label}</p>

            {schema.healthProblems.value ? (
              <div dangerouslySetInnerHTML={{ __html: schema.healthProblems.value }} />
            ) : (
              <div>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>
          <Row style={styles.marginTop1em}>
            <p>
              {schema.artsAndCulture.label}{' '}
              <b>
                {schema.artsAndCulture.value} {schema.reason.label}
              </b>
            </p>

            {schema.reason.value ? (
              <div dangerouslySetInnerHTML={{ __html: schema.reason.value }} />
            ) : (
              <div>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>
          <Row style={styles.marginTop1em}>
            <p>
              {schema.activityArea.label} {schema.activityArea.value}
            </p>
          </Row>
        </Grid>
      </Panel>
    </>
  )
}
